import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Component } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
/**
 * Монтирует дерево оборачиваемого `Target` в отдельную ноду в DOM.
 *
 *  @renderToLayer
 *  class Popup extends Component {
 *
 *    render() {
 *      const {
 *        isOpened,
 *        children,
 *        ...other
 *      } = this.props
 *
 *      return (
 *        <div {...other} style={{ display: isOpened ? 'block' : 'none' }}>
 *          {children}
 *        </div>
 *      )
 *    }
 *
 *  }
 *
 * Передает в оборачиваемый компонент следующие props:
 * - isOpened - контролирует видимость контента
 * - onOpen() - коллбек, который нужно вызвать в `Target` после открытия, например после окончания всех анимаций
 * - onClose() - коллбек, который нужно вызвать в `Target` после закрытия, например после окончания всех анимаций
 */

export default function renderToLayer(Target) {
  var _class, _temp;

  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inherits(RenderToLayer, _Component);

    var _super = _createSuper(RenderToLayer);

    function RenderToLayer() {
      var _this;

      _classCallCheck(this, RenderToLayer);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));
      _this.state = {
        isOpened: _this.props.isOpened || false
      };

      _this.onOpen = function () {
        _this.props.onOpen();
      };

      _this.onClose = function () {
        _this.props.onClose();

        _this.unmountPortal();
      };

      return _this;
    }

    _createClass(RenderToLayer, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (this.props.isOpened) this.mountPortal();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var isOpened = this.props.isOpened;
        if (isOpened !== prevProps.isOpened) if (isOpened) this.mountPortal();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.unmountPortal();
      }
    }, {
      key: "getContentContainerNode",
      value: function getContentContainerNode() {
        if (!this.node) {
          this.node = document.createElement('div');
          this.node.style.position = 'absolute';
          this.node.style.zIndex = this.props.zIndex;
          this.props.containerRef(this.node);
          document.body.appendChild(this.node);
        }

        return this.node;
      }
    }, {
      key: "mountPortal",
      value: function mountPortal() {
        this.setState({
          isOpened: true
        });
      }
    }, {
      key: "unmountPortal",
      value: function unmountPortal() {
        if (this.node) {
          this.props.containerRef();
          this.setState({
            isOpened: false
          });
          document.body.removeChild(this.node);
          this.node = null;
        }
      }
    }, {
      key: "renderContent",
      value: function renderContent() {
        return React.createElement(Target, _extends({}, this.props, {
          onOpen: this.onOpen,
          onClose: this.onClose
        }));
      }
    }, {
      key: "render",
      value: function render() {
        if (!this.state.isOpened) return null;
        return createPortal(this.renderContent(), this.getContentContainerNode());
      }
    }]);

    return RenderToLayer;
  }(Component), _class.propTypes = {
    /**
     * Контролирует видимость
     */
    isOpened: PropTypes.bool,

    /**
     * Значение z-index
     */
    zIndex: PropTypes.number,

    /**
     * Коллбек вызывающийся после открытия
     */
    onOpen: PropTypes.func,

    /**
     * Коллбек вызывающийся после закрытия
     */
    onClose: PropTypes.func,

    /**
     * Коллбек вызывающийся при монтировании/размонтировании контейнера
     */
    containerRef: PropTypes.func
  }, _class.defaultProps = {
    isOpened: false,
    onOpen: function onOpen() {},
    onClose: function onClose() {},
    containerRef: function containerRef() {}
  }, _temp;
}